/**
 * Created by Jerker Nord on 2019-04-11.
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";

export class ThorRuneRazeView extends BaseView {

    private static RUNE_ANIMATION_NAME:string = "Rune";
    private static SPINE_ASSET_NAME:string = "runeRaze";

    private _layer:ScalableLayer;
    private _showRuneRazeTL:TimelineLite;
    private _runeRazeWonAnimation:PIXI.spine.Spine;
    private _runeRazeSymbol:string;
    private _runeRazeSpineTween:SpineTween;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.RUNE_RAZE.name);
        this.alpha = 0;
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._runeRazeWonAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorRuneRazeView.SPINE_ASSET_NAME));
        this._runeRazeWonAnimation.position.set(ThorGameConfig.instance.GAME_WIDTH / 2, (ThorGameConfig.instance.GAME_HEIGHT / 2) - 80);
        this.addChild(this._runeRazeWonAnimation);
    }

    private createShowTL():TimelineLite {
        this._showRuneRazeTL = new TimelineLite();
        this._showRuneRazeTL.add(() => this.alpha = 1);
        this._showRuneRazeTL.add(() => this._runeRazeWonAnimation.skeleton.setSkin(null));
        this._showRuneRazeTL.add(() => this._runeRazeWonAnimation.skeleton.setSkinByName(this.getRuneRazeSymbol()));
        this._showRuneRazeTL.add(() => this._runeRazeWonAnimation.skeleton.setSlotsToSetupPose());
        this._showRuneRazeTL.add([
            this.getRuneRazeSpineTween(),
            this.getSoundTL()
        ]);
        this._showRuneRazeTL.add(() => this.alpha = 0);

        this._runeRazeWonAnimation.state.timeScale = 1;
        this._showRuneRazeTL.timeScale(1);

        //This i a hack to have something returned. The actual _showRuneRazeTL animation needs to execute outside of the main timeline in the controller. Because that one is har set to the end time on abort. But we have our own abort function in this class that handles abort behaviour.
        return new TimelineLite();
    }

    private getSoundTL():TimelineLite {
        const soundTL:TimelineLite = new TimelineLite();
        soundTL.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.RUNE_RAZE_START));
        soundTL.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.RUNE_RAZE_RUNE_SELECT), "+=0.7");
        return soundTL;
    }

    private getRuneRazeSpineTween():SpineTween {
        this._runeRazeSpineTween = new SpineTween(this._runeRazeWonAnimation, 0, ThorRuneRazeView.RUNE_ANIMATION_NAME, 0);
        return this._runeRazeSpineTween;
    }

    private getRuneRazeSymbol():string {
        return this._runeRazeSymbol;
    }

    public getShowRuneRazeTL(runeRazeSymbol:string):TimelineLite {
        this._runeRazeSymbol = runeRazeSymbol;
        return this.createShowTL();
    }

    public abort():void {
        if(this._showRuneRazeTL && this._showRuneRazeTL.isActive() == true) {
            // this.alpha = 0;
            //this._showRuneRazeTL.pause();
            //this._showRuneRazeTL.kill();
            this._runeRazeWonAnimation.state.timeScale = 3;
            this._showRuneRazeTL.timeScale(3);
        }
    }
}